export default __webpack_public_path__ + "static/media/wood2.40a3c1e5.jpg";